import { useState } from 'react'
import { CONTROLLER_TRIGGER } from './controllerTrigger'

/**
 * Both images load before the loop starts; reduced motion keeps the pressed pose.
 * The poses alternate with `opacity`, never `visibility`: a child animated to
 * `visibility: visible` escapes an ancestor's `visibility: hidden`, which let the
 * illustration flash alone while the lobby hid itself on the way into VR.
 */
export function RightControllerIllustration({ className }: { className?: string }) {
  const [loaded, setLoaded] = useState({ rest: false, pressed: false })
  return <div className={className} role="img" aria-label="Mano derecha: el índice aprieta y suelta el gatillo delantero del control"
    style={{ display: 'block', margin: '0 auto', width: '100%', maxWidth: 320, aspectRatio: CONTROLLER_TRIGGER.aspect, position: 'relative' }}
    data-controller-ready={loaded.rest && loaded.pressed}>
    <style>{`
      @keyframes vrs-trigger-rest { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
      @keyframes vrs-trigger-pressed { 0%, 100% { opacity: 0; } 50% { opacity: 1; } }
      .vrs-trigger-pose { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: contain; }
      .vrs-trigger-pressed { opacity: 0; }
      [data-controller-ready="true"] > .vrs-trigger-rest { animation: vrs-trigger-rest ${CONTROLLER_TRIGGER.cycleSeconds}s steps(1, end) infinite; }
      [data-controller-ready="true"] > .vrs-trigger-pressed { animation: vrs-trigger-pressed ${CONTROLLER_TRIGGER.cycleSeconds}s steps(1, end) infinite; }
      @media (prefers-reduced-motion: reduce) {
        [data-controller-ready="true"] > .vrs-trigger-pose { animation: none; }
        [data-controller-ready="true"] > .vrs-trigger-rest { opacity: 0; }
        [data-controller-ready="true"] > .vrs-trigger-pressed { opacity: 1; }
      }
    `}</style>
    <img className="vrs-trigger-pose vrs-trigger-rest" src={CONTROLLER_TRIGGER.rest} alt="" aria-hidden="true" width={768} height={512}
      onLoad={() => setLoaded(value => ({ ...value, rest: true }))} />
    <img className="vrs-trigger-pose vrs-trigger-pressed" src={CONTROLLER_TRIGGER.pressed} alt="" aria-hidden="true" width={768} height={512}
      onLoad={() => setLoaded(value => ({ ...value, pressed: true }))} />
  </div>
}

/**
 * Estilos por clase y no inline para que cada superficie pueda ajustarlos (el
 * lobby del vr-app lo compacta en pantallas de poca altura, `lobby.css`).
 */
export function RightControllerGuide() {
  return <div className="vrs-controller-guide">
    <style>{`
      .vrs-controller-guide { display: flex; align-items: center; justify-content: center; flex-wrap: wrap; gap: 12px; padding: 12px 16px; border: 1px solid var(--color-border, #526075); border-radius: 16px; margin-bottom: 16px; }
      .vrs-controller-guide__image { width: 260px; max-width: 100%; flex-shrink: 0; }
      .vrs-controller-guide__text { flex: 1 1 180px; max-width: 360px; }
    `}</style>
    <div className="vrs-controller-guide__image"><RightControllerIllustration /></div>
    <div className="vrs-controller-guide__text">
      <p style={{ margin: '0 0 6px', fontWeight: 700 }}>Para hacer clic, apretá el gatillo</p>
      <p style={{ margin: 0, lineHeight: 1.5 }}>Agarrá el control con la mano derecha y usá el índice.</p>
    </div>
  </div>
}
